import { v4 as uuidv4 } from 'uuid';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const createRandomId = (): string => {
  return uuidv4();
};
